import { Button, typography } from '@joor/design-system'
import { Progress } from 'semantic-ui-react'
import styled from 'styled-components'

export const OptionButton = styled(Button)`
  margin: 80px 20px 0px 0px !important;
  width: 120px;
`

export const ButtonsWrapper = styled.div`
  display: flex;
`

export const ProgressBar = styled(Progress)`
  width: 460px;
  align-self: center;
  height: auto;
  border-radius: 5px !important;
  height: auto;
  overflow: visible;
  & > .label {
    ${typography.alpha.primaryActive.subtitle3};
    padding-top: 15px;
    font-weight: 500 !important;
    font-style: normal !important;
    font-size: 14px !important;
    line-height: 16px !important;
  }
  & > .bar {
    background-color: var(--color-secondary-600) !important;
    border-radius: 5px !important;
  }
  & > .error {
    background-color: red !important;
  }
`

export const Container = styled.div`
  padding: 64px 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: white;
`
